import { render, staticRenderFns } from "./FCellTextEllipsis.vue?vue&type=template&id=61b3ba1a&scoped=true&"
import script from "./FCellTextEllipsis.vue?vue&type=script&lang=ts&"
export * from "./FCellTextEllipsis.vue?vue&type=script&lang=ts&"
import style0 from "./FCellTextEllipsis.vue?vue&type=style&index=0&id=61b3ba1a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61b3ba1a",
  null
  
)

export default component.exports